var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 15.4286L14.2857 12L10.8571 8.57147M14.2857 12H4",
    stroke: "#14FFEC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14285 9.7143V6.27659C5.14285 5.67196 5.38241 5.09196 5.80909 4.66357C6.23577 4.23518 6.8148 3.99329 7.41942 3.99087L16.5074 3.9543C16.8077 3.9531 17.1052 4.01107 17.3831 4.1249C17.6609 4.23873 17.9136 4.40619 18.1268 4.61771C18.3399 4.82923 18.5092 5.08067 18.6251 5.35765C18.741 5.63464 18.8012 5.93176 18.8023 6.23202L18.848 17.6937C18.8492 17.9939 18.7913 18.2914 18.6775 18.5691C18.5638 18.8469 18.3964 19.0996 18.185 19.3127C17.9736 19.5258 17.7223 19.6951 17.4454 19.8111C17.1686 19.9271 16.8716 19.9874 16.5714 19.9886H7.42857C6.82236 19.9886 6.24098 19.7478 5.81232 19.3191C5.38367 18.8905 5.14285 18.3091 5.14285 17.7029V14.2857",
    stroke: "#14FFEC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.e4339f5525903ab6758211da17e848b7.svg";
export { ForwardRef as ReactComponent };